const config_bucket_count = {
    animationEnabled: true,
    theme: "light2",
    title:{
      text: "Febreza Pantera"
    },
    axisY: {
      title: "Performance",
      includeZero: true
    },
    data: [{
      type: "bar",
      dataPoints: []
    }]
};

export { config_bucket_count };